import { UserAccessHandler } from '@sennder/shell-utilities'
import { getStateData } from '@/store/getters'
import { featureFlag } from '@/services/featureFlagProvider'

/**
 * Access handlers are functions which return a boolean. They can be used as menu visibility handlers, and called in route guards.
 *
 * NAMING CONVENTIONS
 *
 * Access handler name should be a sentence which describes what access it checks, or user role it checks.
 *
 * - userIs{Role}: Check if the user has a specific role
 * - canAccess{Page}: Check if the user has access to the page
 */

export const canAccessMarketplace: UserAccessHandler = () =>
  !getStateData().hasOnboardingFormAccess

export const canAccessOnboarding: UserAccessHandler = () =>
  !!getStateData().hasOnboardingFormAccess

export const canAccessTenders: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('ENABLE_TENDERING-SIDE-MENU')

export const canAccessPlanner: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('microfrontend-planner')

export const canAccessProfile: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('microfrontend-profile')

export const canAccessSennfuel: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('sennfuel-microfrontend')

export const canAccessSennfuelLp: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('lp-sennfuel-microfrontend')

export const canAccessContracts: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('chartering')
